// services/city.service.ts

import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { eps } from './url.service'

@Injectable({
  providedIn: 'root'
})
export class CityService {
  private apiUrl = eps.auth.cityApi
  constructor(private http: HttpClient) {}

  getCitiesByState(stateId: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${stateId}`)
  }
}
